import { createContext } from 'react';

const registeredUserContext = createContext();

export default registeredUserContext;
